import useDetectKeyboardOpen from './useDetectKeyboardOpen';

export function useVirtualKeyboardVisible() {
  const isOpenKeyboard = useDetectKeyboardOpen();

  return isOpenKeyboard;
}
